import React from 'react';
import { useChatContext } from 'stream-chat-react';

const useChannelMute = (channel) => {
    const { client } = useChatContext();
    const [{ muted }, setMuteStatus] = React.useState(() => channel.muteStatus());
    React.useEffect(() => {
        const updateMuteState = () => {
            setMuteStatus(channel.muteStatus());
        };
        client.on("notification.channel_mutes_updated", updateMuteState);
        return () => client.off("notification.channel_mutes_updated", updateMuteState);
    }, []);
    return muted;
};

export { useChannelMute };
//# sourceMappingURL=use_channel_mute.js.map
